export enum CommandCenter {
  BUILD = "BUILD",
  PARAM = "PARAM",
  REBOOT = "REBOOT",
  GET_TIME = "GET_TIME",
  SET_TIME = "SET_TIME",
  RKL = "RKL"
}

